/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealEstateDto } from './RealEstateDto';
import {
    RealEstateDtoFromJSON,
    RealEstateDtoFromJSONTyped,
    RealEstateDtoToJSON,
    RealEstateDtoToJSONTyped,
} from './RealEstateDto';

/**
 * 
 * @export
 * @interface SearchBiensProprietaireResponse
 */
export interface SearchBiensProprietaireResponse {
    /**
     * Page de biens du propriétaire
     * @type {Array<RealEstateDto>}
     * @memberof SearchBiensProprietaireResponse
     */
    items: Array<RealEstateDto>;
    /**
     * Nombre total de biens correspondant au filtre
     * @type {number}
     * @memberof SearchBiensProprietaireResponse
     */
    totalCount: number;
}

/**
 * Check if a given object implements the SearchBiensProprietaireResponse interface.
 */
export function instanceOfSearchBiensProprietaireResponse(value: object): value is SearchBiensProprietaireResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function SearchBiensProprietaireResponseFromJSON(json: any): SearchBiensProprietaireResponse {
    return SearchBiensProprietaireResponseFromJSONTyped(json, false);
}

export function SearchBiensProprietaireResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchBiensProprietaireResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RealEstateDtoFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function SearchBiensProprietaireResponseToJSON(json: any): SearchBiensProprietaireResponse {
    return SearchBiensProprietaireResponseToJSONTyped(json, false);
}

export function SearchBiensProprietaireResponseToJSONTyped(value?: SearchBiensProprietaireResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(RealEstateDtoToJSON)),
        'totalCount': value['totalCount'],
    };
}

